export default __webpack_public_path__ + "static/media/ANG.9ecb75cf.svg";